<template>
  <div>
    <LeftListSupplier :pos="10"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li on">
            <router-link to="/download-center" class="txt"
              >全部订单</router-link
            >
          </li>
          <li class="li">
            <router-link to="/task-center" class="txt">已提交</router-link>
          </li>
          <li class="li">
            <router-link to="/task-center" class="txt">已取消</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="order-content">
            <div class="all-order-tit">全部订单</div>
            <div class="order-top">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div class="function-list">
                <div class="ftit fzt">状态</div>
                <div class="ftit xx">订单详细</div>
                <div class="ftit cz">操作</div>
              </div>
            </div>

            <div v-for="(item, index) in orderbox" class="order-li">
              <div class="order-func">
                <div class="time">{{ item.time }}</div>
                <div class="number">{{ item.number }}</div>
                <div class="function-list">
                  <div class="ftit fzt">&nbsp;</div>
                  <div class="ftit xx">&nbsp;</div>
                  <div class="ftit cz">{{ item.state }}</div>
                </div>
              </div>
              <div class="order-box">
                <div class="left">
                  <div class="number t">
                    订单号&nbsp;&nbsp;&nbsp;{{ item.number }}
                  </div>
                  <div class="name t">
                    {{ item.name }}
                  </div>
                  <div class="id t">
                    {{ item.id }}
                  </div>
                </div>
                <div class="function-list">
                  <div class="ftit fzt">{{ item.state2 }}</div>
                  <div
                    @click="toggleActive(index)"
                    class="ftit xx ck"
                    :class="{ on: item.showtable }">
                    查看详细
                  </div>
                  <div class="ftit cz buttonlist">
                    <el-button type="primary" icon="el-icon-download"
                      >导出订单</el-button
                    >
                    <el-button type="primary" icon="el-icon-download"
                      >MARC数据下载</el-button
                    >
                  </div>
                </div>
              </div>
              <div class="table" v-show="item.showtable">
                <el-table :data="item.tableData" style="width: 100%">
                  <el-table-column prop="isbn" label="ISBN" width="140">
                  </el-table-column>
                  <el-table-column prop="bookname" label="书名" width="180">
                  </el-table-column>
                  <el-table-column prop="cbs" label="出版社" width="140">
                  </el-table-column>
                  <el-table-column prop="author" label="作者" width="80">
                  </el-table-column>
                  <el-table-column prop="cbtime" label="出版日期" width="108">
                  </el-table-column>
                  <el-table-column prop="ystime" label="印刷日期" width="108">
                  </el-table-column>
                  <el-table-column prop="yz" label="印张" width="70">
                  </el-table-column>
                  <el-table-column prop="price" label="定价" width="70">
                  </el-table-column>
                  <el-table-column prop="zk" label="折扣" width="70">
                  </el-table-column>
                  <el-table-column prop="supplier" label="供应商" width="240">
                    <template slot-scope="scope">
                      <a href="javascript:;">{{ scope.row.supplier }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ddnumber" label="订单数">
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div class="fy">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="400">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <protocol-dialog
      :show.sync="protocol.show"
      :type="protocol.type"></protocol-dialog>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import ProtocolDialog from "@/components/ProtocolDialog.vue";
import dayjs from "dayjs";
export default {
  components: {
    ProtocolDialog,
    LeftListSupplier,
  },
  data() {
    return {
      currentPage4: 4,
      orderbox: [
        {
          time: "2024-03-20  20:28:47",
          number: "284839426054",
          state: "恢复订单",
          name: "唐庆伟",
          id: "18910554065",
          state2: "已提交",
          showtable: false,
          tableData: [
            {
              isbn: "9787569941920",
              bookname: "python编程从入门到精通",
              cbs: "北京时代华文书局",
              author: "王博文",
              cbtime: "2023/8/1",
              ystime: "2023/8/1",
              yz: 476,
              price: 48,
              zk: 22,
              supplier: "北京海洋天博文化传播有限公司",
              ddnumber: 100,
            },
            {
              isbn: "9787569941920",
              bookname: "python编程从入门到精通",
              cbs: "北京时代华文书局",
              author: "王博文",
              cbtime: "2023/8/1",
              ystime: "2023/8/1",
              yz: 476,
              price: 48,
              zk: 22,
              supplier: "北京海洋天博文化传播有限公司",
              ddnumber: 100,
            },
            {
              isbn: "9787569941920",
              bookname: "python编程从入门到精通",
              cbs: "北京时代华文书局",
              author: "王博文",
              cbtime: "2023/8/1",
              ystime: "2023/8/1",
              yz: 476,
              price: 48,
              zk: 22,
              supplier: "北京海洋天博文化传播有限公司",
              ddnumber: 100,
            },
            {
              isbn: "9787569941920",
              bookname: "python编程从入门到精通",
              cbs: "北京时代华文书局",
              author: "王博文",
              cbtime: "2023/8/1",
              ystime: "2023/8/1",
              yz: 476,
              price: 48,
              zk: 22,
              supplier: "北京海洋天博文化传播有限公司",
              ddnumber: 100,
            },
            {
              isbn: "9787569941920",
              bookname: "python编程从入门到精通",
              cbs: "北京时代华文书局",
              author: "王博文",
              cbtime: "2023/8/1",
              ystime: "2023/8/1",
              yz: 476,
              price: 48,
              zk: 22,
              supplier: "北京海洋天博文化传播有限公司",
              ddnumber: 100,
            },
            {
              isbn: "9787569941920",
              bookname: "python编程从入门到精通",
              cbs: "北京时代华文书局",
              author: "王博文",
              cbtime: "2023/8/1",
              ystime: "2023/8/1",
              yz: 476,
              price: 48,
              zk: 22,
              supplier: "北京海洋天博文化传播有限公司",
              ddnumber: 100,
            },
          ],
        },
      ],
      options: [
        {
          value: "选项1",
          label: "2023年订单",
        },
        {
          value: "选项2",
          label: "2022年订单",
        },
        {
          value: "选项3",
          label: "2021年订单",
        },
        {
          value: "选项4",
          label: "2020年订单",
        },
        {
          value: "选项5",
          label: "2019年订单",
        },
      ],
      value: "",

      protocol: {
        type: "bk_supplier_vip",
        show: false,
      },
      form: {
        id: null,
        name: "",
        priority: null,
      },
      formRules: {
        name: [
          { required: true, message: "请输入服务器名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        priority: [
          { required: true, message: "请选择优先级", trigger: "change" },
        ],
      },
      nextId: 4,
    };
  },
  computed: {
    dialogTitle() {
      return this.dialogType === "add" ? "新增服务器" : "修改服务器";
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isVip() {
      return (
        dayjs(this.$store.state.user.userInfo.vipTime).unix() > dayjs().unix()
      );
    },
  },
  mounted() {},
  methods: {
    toggleActive(index) {
      console.log(123);
      this.orderbox[index].showtable = !this.orderbox[index].showtable;
    },
  },
};
</script>

<style lang="scss" scoped></style>
